export default __webpack_public_path__ + "dd8aa09b1e941b6a42048b0f6920282e.gif";